/**
 * Übersetzt Fehler des lokalen Logins (Better-Auth signIn.email) in einen Satz
 * für die Oberfläche (r105): Ablehnung (endgültig, über das Ziel) und
 * Fehlschlag (wiederholbar) haben verschiedene Sätze; ein roher Fehlercode
 * oder englischer Bibliothekstext erscheint nie.
 *
 * Bekannte deutsche Sperrmeldungen aus session.create.before (gelöscht,
 * deaktiviert, System-Benutzer, Wartung) bleiben wörtlich erhalten — sie sind
 * bereits Sätze und steuern den Kontakt-Hinweis.
 */

export const UNBEKANNTER_FEHLSCHLAG = "Die Anmeldung ist fehlgeschlagen. Bitte erneut versuchen.";
export const MICROSOFT_FEHLSCHLAG = "Die Anmeldung mit Microsoft ist fehlgeschlagen. Bitte erneut versuchen.";
export const FALSCHE_ZUGANGSDATEN = "E-Mail oder Passwort ist falsch.";
export const ZU_VIELE_VERSUCHE = "Zu viele Anmeldeversuche. Bitte in einigen Minuten erneut versuchen.";
export const EMAIL_NICHT_BESTAETIGT = "Die E-Mail-Adresse ist noch nicht bestätigt.";

/** Server-Schlüssel (offboarding-guard / auth.ts) → angezeigter Satz (identisch zur OAuth-Fehlerseite). */
const SPERR_SAETZE: Array<[string, string]> = [
  ["Dieser_Benutzer_wurde_geloescht._Bitte_den_Administrator_kontaktieren.", "Dieser Benutzer wurde gelöscht. Bitte den Administrator kontaktieren."],
  ["Dieser_Benutzer_ist_deaktiviert._Bitte_den_Administrator_kontaktieren.", "Dieser Benutzer ist deaktiviert. Bitte den Administrator kontaktieren."],
  ["System-Benutzer_koennen_sich_nicht_anmelden.", "System-Benutzer können sich nicht anmelden."],
  ["Wartungsmodus_aktiv._Bitte_versuchen_Sie_es_spaeter_erneut.", "Die Plattform ist aktuell im Wartungsmodus. Bitte versuchen Sie es später erneut."],
];

/** Vergleichsform: Unterstriche wie Leerzeichen, ae/oe/ue wie Umlaute (Server-Throws sind teils ASCII). */
function normalisiere(s: string): string {
  return s
    .replace(/_/g, " ")
    .replace(/ae/g, "ä")
    .replace(/oe/g, "ö")
    .replace(/ue/g, "ü")
    .trim()
    .toLowerCase();
}

export function beschreibeAnmeldefehler(err: { code?: string; message?: string; status?: number }): string {
  if (err.code === "INVALID_EMAIL_OR_PASSWORD" || err.code === "INVALID_EMAIL" || err.code === "INVALID_PASSWORD") {
    return FALSCHE_ZUGANGSDATEN;
  }
  if (err.status === 429) return ZU_VIELE_VERSUCHE;
  if (err.code === "EMAIL_NOT_VERIFIED") return EMAIL_NICHT_BESTAETIGT;
  if (err.message) {
    const m = normalisiere(err.message);
    const treffer = SPERR_SAETZE.find(([schluessel, satz]) => normalisiere(schluessel) === m || normalisiere(satz) === m);
    if (treffer) return treffer[1];
  }
  return UNBEKANNTER_FEHLSCHLAG;
}
